import { render, staticRenderFns } from "./addShip.vue?vue&type=template&id=545d4b1f&scoped=true"
import script from "./addShip.vue?vue&type=script&lang=js"
export * from "./addShip.vue?vue&type=script&lang=js"
import style0 from "./addShip.vue?vue&type=style&index=0&id=545d4b1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545d4b1f",
  null
  
)

export default component.exports